//--------------------------------------------------
// imported classes
//--------------------------------------------------
const ClassFunc = require('../../../util/ClassFunc')
const Stats = require('./Stats')
/**
 * The Organization class acts as the view object for the organization.
 */
const tbs_model_vo_icehockey_UserPlayerProfile = function() {
    //--------------------------------------------------
    // super method for the base class
    //--------------------------------------------------
    ClassFunc.super(this, Stats, arguments)
}

//--------------------------------------------------
// prototype
//--------------------------------------------------
tbs_model_vo_icehockey_UserPlayerProfile.prototype = {
    /* The view object name */
    name: 'player',
    /* The view object instance */
    view: {
        get: [
            {
                name: 'fact',
                baseUrl: process.env.VUE_APP_BJHSU_API,
                apiPrefix: '/api/rpes/',
                apiSuffix: 'accessKey=bjh-user-rpes',
                service: 'players/facts',
                query: {
                    passport: 'passport',
                    id: 'playerId'
                },
                basePath: '0',
                rule: {
                    id: 'playerId',
                    avatar: 'profile',
                    name: 'trueName',
                    gender: '$gender',
                    age: '$birthDay',
                    birthday: '$birthDay',
                    nationality: 'nationality',
                    height: '$high',
                    weight: '$weight',
                    position: 'position',
                    role: '$position',
                    sc: 'stickHand',
                    organizationName: 'organizationName',
                    playerNo: 'jerseyNo',
                    school: 'schoolName',
                }
            },
            {
                name: 'selections',
                baseUrl: process.env.VUE_APP_BJHSU_API,
                apiPrefix: '/api/rpes/',
                apiSuffix: 'accessKey=bjh-user-rpes',
                service: 'players/selections',
                query: {
                    passport: 'passport',
                    id: 'playerId'
                },
                basePath: '',
                rule: {
                    level: '$level',
                    season: 'season',
                    name: 'name',
                }
            },
            {
                name: 'season',
                baseUrl: process.env.VUE_APP_BJHSU_API,
                apiPrefix: '/api/rpes/',
                apiSuffix: 'accessKey=bjh-user-rpes',
                service: 'players/season/period',
                query: {
                    passport: 'passport',
                    id: 'playerId'
                },
                basePath: '0',
                rule: {
                    seasonPeriod: '$minSeason,maxSeason'
                }
            },
            {
                name: 'summary',
                baseUrl: process.env.VUE_APP_BJHSU_API,
                apiPrefix: '/api/rpes/',
                apiSuffix: 'accessKey=bjh-user-rpes',
                service: 'players/stats/summary',
                query: {
                    passport: 'passport',
                    id: 'playerId'
                },
                basePath: '0',
                rule: {
                    season: 'seasonTotal',
                    match: 'matchTotal',
                    game: 'gameTotal',
                }
            },
            {
                name: 'list',
                baseUrl: process.env.VUE_APP_HOCKEY_API, 
                apiPrefix: '/hockey/',
                service: 'getMyPlayerMemberShipList',
                query: {
                    passport: 'passport',
                },
                basePath: 'data.list',
                rule: {
                    label: '$jerseyNo,trueName,position',
                    value: 'id',
                    role: '$position'
                }
            },
            {
                name: 'product',
                baseUrl: process.env.VUE_APP_PASS_API,
                apiPrefix: '/api/',
                service: 'GetEventSkuDetail.json',
                query: {
                    skuId: '(801)',
                },
                basePath: 'data.detail',
                rule: {
                    tag: 'name',
                    price: '$price',
                }
            },
        ],
        order: {
            baseUrl: process.env.VUE_APP_PASS_API,
            apiPrefix: '/api/',
            service: 'BJHCreateMembershipDataOrder.json',
            basePath: '',
            rule: {
                membershipId: 'playerId',
                needNew: '(1)',
                membershipName: 'playerName'
            }
        },
    },
    renderLabel: function(jerseyNo, trueName, position) {
        return '#' + (jerseyNo ? jerseyNo : '') + ' ' + trueName + ' ' + (position ? position : '')
    },
    renderPrice: function(price) {
        return (price / 100).toString()
    }
}

//--------------------------------------------------
// extends the Stats
//--------------------------------------------------
ClassFunc.extend(tbs_model_vo_icehockey_UserPlayerProfile, Stats)

module.exports = tbs_model_vo_icehockey_UserPlayerProfile